import jsPsychAudioButtonResponse from '@jspsych/plugin-audio-button-response';
import store from 'store2';
import { camelize } from '@bdelab/roar-utils';
import { mediaAssets, updateProgressBar } from '../helperFunctions';
import { jsPsych } from '../jsPsych';
import { vocabValidityEvaluator } from '../experiment';

let source;

export const multiAFC = (numAFC, trialType) => ({
  type: jsPsychAudioButtonResponse,
  on_load: () => {
    const replayBtn = document.getElementById('replay');

    async function replayAudio() {
      const jsPsychAudioCtx = jsPsych.pluginAPI.audioContext();

      // Returns a promise of the AudioBuffer of the preloaded file path.
      const audioBuffer = await jsPsych.pluginAPI.getAudioBuffer(
        mediaAssets.audio[camelize(store.session('currentStimulus'))],
      );

      source = jsPsychAudioCtx.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(jsPsychAudioCtx.destination);
      source.start(0);
      store.session.transact('ifReplay', (oldVal) => oldVal + 1);

      // replayBtn.disabled = 'disabled';
      // replayBtn.style.color = 'rgba(255, 255, 255, 0)';
      // replayBtn.style.background = 'rgba(255, 255, 255, 0)';
      // replayBtn.style.border = 'rgba(255, 255, 255, 0)';
    }
    replayBtn.addEventListener('click', replayAudio);
  },
  prompt: () =>
    `<img class = "speaker" id="replay" draggable="false" src="${mediaAssets.images.iconSpeaker}" alt="replay" />
`,
  stimulus: () => {
    store.session.set('currentStimulus', store.session.get('nextStimulus').target.toUpperCase());
    return mediaAssets.audio[camelize(store.session.get('currentStimulus'))];
  },
  choices: () => store.session('nextStimulus').choices,
  button_html: () => {
    const list = [
      '<img class="vocab_img" style="border: 2vh solid #F0E442;" draggable="false" src="%choice%" alt="response" />',
      '<img class="vocab_img" style="border: 2vh solid #0072B2;" draggable="false" src="%choice%" alt="response" />',
      '<img class="vocab_img" style="border: 2vh solid #009E73;" draggable="false" src="%choice%" alt="response" />',
      '<img class="vocab_img" style="border: 2vh solid #DC3220;" draggable="false" src="%choice%" alt="response" />',
    ];
    return list.slice(0, numAFC);
  },
  data: {
    save_trial: true,
    assessment_stage: trialType,
    start_time: store.session.get('config').startTime.toLocaleString(),
    start_time_unix: new Date(store.session.get('config').startTime).getTime(),
  },
  on_start: () => {
    /* document.addEventListener('mousemove', (event) => {
      const customCursor = document.querySelector('.custom-cursor');
      customCursor.style.left = `${event.clientX - customCursor.offsetWidth / 2  }px`;
      customCursor.style.top = `${event.clientY - customCursor.offsetHeight / 2  }px`;
    });
    */
  },
  on_finish: (data) => {
    // eslint-disable-next-line no-param-reassign
    data.correct = data.response === store.session('targetRespNum') ? 1 : 0;
    store.session.set('currentTrialCorrect', data.correct);
    store.session.set('response', data.correct);

    if (trialType === 'test_response') {
      updateProgressBar(false);

      if (data.correct === 1) {
        store.session.transact('totalCorrect', (oldVal) => oldVal + 1);
      }
    }

    const totalCorrect = store.session.get('totalCorrect');
    const trialNumTotal = store.session.get('trialNumTotal');
    const totalPercentCorrect = Math.round((totalCorrect / trialNumTotal) * 100);

    store.session.set('totalPercentCorrect', totalPercentCorrect);

    // feed response to vocabValidityEvaluator for evaluation per trial
    vocabValidityEvaluator.addResponseData(data.rt, data.response, data.correct);

    jsPsych.data.addDataToLastTrial({
      block: trialType === 'practice_response' ? 'practice' : store.session.get('currentBlockIndex'),
      targetWord: store.session.get('nextStimulus').target,
      answerWord: store.session.get('nextStimulus').words[data.response],
      options: store.session.get('nextStimulus').words,
      assessment_stage: data.assessment_stage,
      correct: data.correct,
      correctSide: store.session.get('targetRespNum'),
      stimulusRule: store.session.get('stimulusRule'),
      trialNumTotal: store.session.get('trialNumTotal'),
      trialNumBlock: store.session.get('trialNumBlock'),
      itemType: store.session.get('nextStimulus').itemType,
      itemSource: store.session.get('nextStimulus').itemSource,
      numAFC: numAFC,
      replay: store.session.get('ifReplay'),
      pid: store.session.get('config').pid,
      sessionId: store.session.get('config').sessionId,
    });
    store.session.set('ifReplay', 0);

    if (source) {
      source.stop();
    }
  },
});
